import styled from "styled-components";
import { NavLink } from 'react-router-dom';

import { NavbarItemProps, NavbarLineProps } from "./props";

export const NavbarSectionContainer = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--nav-surface);
  backdrop-filter: blur(12px);
  border-style: none none solid none;
  border-color: var(--line);
  border-width: 1px;
`;

export const Navbar = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1080px;
  margin: 0 auto;
  align-items: center;
  @media (max-width: 768px) {
    max-width: 320px;
  }
`;

export const NavbarRight = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    gap: 14px;
    margin-right: 12px;
  }
`;

export const NavbarLeft = styled.div``;

export const NavbarItem = styled.a<NavbarItemProps>`
  margin-left: ${({ margin }) => margin?.left || 24}px;
  margin-right: ${({ margin }) => margin?.right || 24}px;
  margin-top: ${({ margin }) => margin?.top || 24}px;
  margin-bottom: ${({ margin }) => margin?.bottom || 24}px;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 0px;
  transition: 0.2s ease;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--text);
  position: relative;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 100%;
    bottom: 0;
    height: 1px;
    background-color: var(--text);
    transition: right 0.2s ease;
  }
  &:hover {
    &:after {
      right: 0;
    }
  }
  @media (max-width: 768px) {
    font-size: 14px;
    margin: 0px;
    height: 20px;
  }
`;

export const NavbarLink = styled(NavLink)`
  margin-left: 24px;
  margin-right: 24px;
  margin-top: 24px;
  margin-bottom: 24px;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 0px;
  transition: 0.2s ease;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--text);
  position: relative;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    right: 100%;
    bottom: 0;
    height: 1px;
    background-color: var(--text);
    transition: right 0.2s ease;
  }
  &:hover {
    &:after {
      right: 0;
    }
  }
  @media (max-width: 768px) {
    font-size: 14px;
    margin: 0px;
    height: 20px;
  }
`;

export const NavbarLogo = styled.img`
  margin: 12px 0px;
  cursor: pointer;
  width: 80px;
  filter: var(--illustration-filter);
  transition: filter 0.24s ease;
  @media (max-width: 768px) {
    margin: 0px;
    margin-top: 12px;
    margin-bottom: 12px;
  }
`;

export const ThemeToggle = styled.button`
  display: grid;
  width: 30px;
  height: 30px;
  margin-left: 4px;
  padding: 0px;
  place-items: center;
  border: 1px solid var(--line);
  border-radius: 50%;
  color: var(--text);
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &:hover {
    border-color: var(--text);
    color: var(--page);
    background: var(--text);
  }

  &:focus-visible {
    outline: 2px solid var(--text);
    outline-offset: 3px;
  }

  svg {
    width: 15px;
    height: 15px;
  }

  @media (max-width: 768px) {
    width: 25px;
    height: 25px;
    margin-left: 2px;

    svg {
      width: 13px;
      height: 13px;
    }
  }
`;

export const NavbarLine = styled.div<NavbarLineProps>`
  background-color: #00baeb;
  height: 2px;
  width: ${(props) => props.percentage}%;
`;
